"use client";
import { rem } from "../../core/utils/units-converters/rem.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Radio/RadioIcon.tsx
function RadioIcon({ size, style, ...others }) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 5 5",
		style: {
			width: rem(size),
			height: rem(size),
			...style
		},
		"aria-hidden": true,
		...others,
		children: /* @__PURE__ */ jsx("circle", {
			cx: "2.5",
			cy: "2.5",
			r: "2.5",
			fill: "currentColor"
		})
	});
}
//#endregion
export { RadioIcon };

//# sourceMappingURL=RadioIcon.mjs.map